const routes = {
    landingWebview: {
        path: '/webview'
    },
    landing: {
        path: '/'
    },
    login: {
        path: '/login'
    },
    registration: {
        path: '/registration'
    },
    resetPasswordRequest: {
        path: '/reset-password/request'
    },
    resetPasswordChange: {
        path: '/reset-password/change'
    },
    warehouseDetail: {
        path: '/location/:id'
    },
    warehouseSearch: {
        path: '/boxes'
    },
    shipments: {
        path: '/shipments'
    },
    orderUserDetails: {
        path: '/order/user-details'
    },
    orderSummary: {
        path: '/order/summary'
    },
    orderOffer: {
        path: '/order/first'
    },
    orderOfferBox: {
        path: '/order/box/:boxName'
    },
    orderStatusCheck: {
        path: '/order/status-check'
    },
    help: {
        path: '/help'
    },
    gdpr: {
        path: '/gdpr'
    },
    storePolicy: {
        path: '/store-policy'
    },
    franchising: {
        path: '/franchising'
    },
    myContracts: {
        path: '/my/contracts'
    },
    cancelContract: {
        path: '/my/contracts/:id/cancel'
    },
    myContractDetail: {
        path: '/my/contracts/:id'
    },
    myProfile: {
        path: '/my/profile'
    },
    deleteAccount: {
        path: '/my/profile/delete'
    },
    myBoxes: {
        path: '/my/boxes'
    },
    changePassword: {
        path: '/my/profile/change-password'
    },
    myRents: {
        path: '/my/rents'
    },
    confirmEviction: {
        path: '/my/contracts/:id/eviction'
    },
    serviceAccess: {
        path: '/service-access'
    },
    qrAccess: {
        path: '/qr-access'
    }
}

export default routes
